import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { TipoEstadoCivil } from 'src/app/models/enum/tipo-estado-civil.enum';
import { TipoMatrimonioUnionCivil } from 'src/app/models/enum/tipo-matrimonio-civil.enum';
import { TipoNacionalidad } from 'src/app/models/enum/tipo-nacionalidad.enum';
import { TipoSexo } from 'src/app/models/enum/tipo-sexo.enum';
import { TipoVivienda } from 'src/app/models/enum/tipo-vivienda.enum';
import { CommonService } from 'src/app/services/common.service';
import { DataService } from 'src/app/services/data.service';
import { PersonaService } from 'src/app/services/persona.service';
import { StepperService } from 'src/app/services/stepper.service';
import Swal from 'sweetalert2';
@Component({
  selector: 'app-identificacion-cliente',
  templateUrl: './identificacion-cliente.component.html',
  styleUrls: ['./identificacion-cliente.component.css']
})
export class IdentificacionClienteComponent implements OnInit {

  tipoVivienda: TipoVivienda | any = TipoVivienda;
  tipoSexo: TipoSexo | any = TipoSexo;
  tipoEstadoCivil: TipoEstadoCivil | any = TipoEstadoCivil;
  tipoMatrimonioUnionCivil: TipoMatrimonioUnionCivil | any = TipoMatrimonioUnionCivil;
  tipoNacionalidad: TipoNacionalidad | any = TipoNacionalidad;
  form: FormGroup | any;
  persona: any;
  hoy: Date = new Date();
  constructor(private fb: FormBuilder, private stepperService: StepperService, private commonService: CommonService, private dataService: DataService,
    private personaService: PersonaService) {
    this.form = this.fb.group({
      guid: new FormControl('',[Validators.required]),
      rut: new FormControl('', [Validators.required, Validators.pattern(/^[1-9]\d*[-|‐]{1}[0-9kK]{1}$/), commonService.createRutValidator()]),
      nombre: new FormControl('', [Validators.required, Validators.pattern('^[A-Za-zÁáÉéÍíÓóÚúÜüÑñ ]+$')]),
      apellidoPaterno: new FormControl('', [Validators.required, Validators.pattern('^[A-Za-zÁáÉéÍíÓóÚúÜüÑñ ]+$')]),
      apellidoMaterno: new FormControl('',[Validators.required, Validators.pattern('^[A-Za-zÁáÉéÍíÓóÚúÜüÑñ ]+$')]),
      tipoEstadoCivil: new FormControl('',[Validators.required]),
      tipoNacionalidad: new FormControl('',[Validators.required]),
      paisNacionalidad: new FormControl('', [Validators.required]),
      tipoSexo: new FormControl('',[Validators.required]),
      tipoRegimenPatrimonial: new FormControl({value: '', disabled: true}),
      tipoVivienda: new FormControl(null,[Validators.required]),
      otroTipoVivienda: new FormControl(''),
      fechaNacimiento: new FormControl(null, [Validators.required]),
      montoArriendo: new FormControl(null),
      email: new FormControl('', [Validators.required, Validators.email]),
      celular: new FormControl('', [Validators.required, Validators.pattern(/^(\+?56)?(\s?)(0?9)(\s?[98765432])\d{7}$/)]),
    });
  }

  calcularMayorEdad(fecha: Date): boolean {
    const hoy = new Date();
    const fechaNacimiento = new Date(fecha);
    const edad = hoy.getFullYear() - fechaNacimiento.getFullYear();
    if (edad < 18) {
      return false;
    }
    return edad >= 18;
  }
  


  getTipoViviendaKeys(): string[] {
      const sortedKeys = Object.keys(TipoVivienda).sort();
      const otrosIndex = sortedKeys.indexOf('Otro');
    
      if (otrosIndex > -1) {
        sortedKeys.splice(otrosIndex, 1); // Eliminar "Otros" de su posición actual
        sortedKeys.push('Otro'); // Agregar "Otros" al final
      }
    
      return sortedKeys;
  }

  getTipoSexoKeys(): string[] {
    return Object.keys(TipoSexo).sort();
  }

  getTipoEstadoCivilKeys(): string[] {
    return Object.keys(TipoEstadoCivil).sort();
  }

  getTipoMatrimonioUnionCivilKeys(): string[] {
    return Object.keys(TipoMatrimonioUnionCivil).sort();
  }

  getTipoNacionalidadKeys(): string[] {
    return Object.keys(TipoNacionalidad).sort();
  }

  ngOnInit(): void {
    this.form.get('otroTipoVivienda').disable();
    this.form.get('montoArriendo').disable();
    this.form.get('rut').disable();
    this.form.get('tipoRegimenPatrimonial').disable();
    this.personaService.persona$.subscribe((persona) => {
      if (persona) {
        this.persona = persona;
        this.commonService.setFormGroupValues(this.form, persona.identificacionPersona);
        this.tipoNacionalidadChange(persona.identificacionPersona.tipoNacionalidad);
        this.tipoViviendaChange(persona.identificacionPersona.tipoVivienda);
        this.tipoEstadoCivilChange(persona.identificacionPersona.tipoEstadoCivil);
        // Establecer el valor de paisNacionalidad
        this.form.get('paisNacionalidad')?.setValue(persona.identificacionPersona.paisNacionalidad);
        this.form.get('tipoRegimenPatrimonial')?.setValue(persona.identificacionPersona.tipoRegimenPatrimonial);
        this.form.get('montoArriendo')?.setValue(persona.identificacionPersona.montoArriendo);
        this.form.get('otroTipoVivienda')?.setValue(persona.identificacionPersona.otroTipoVivienda);
        if (persona.estadoSituacion?.estadoFormularioSituacion == 'Firmado') {
          this.form.disable();
        }
        if (persona.identificacionPersona.fechaNacimiento) {
          this.form.get('fechaNacimiento')?.setValue(new Date(persona.identificacionPersona.fechaNacimiento));
        }
      }
    });
    
  }
  onPhoneInput() {
    const phoneControl = this.form.get('celular');
    if (phoneControl) {
      let value = phoneControl.value || '';
      // Agregar +569 si no está presente y el campo no está vacío
      if (value && !value.startsWith('+569')) {
        value = '+569' + value.replace(/[^0-9]/g, ''); // Solo números después del prefijo
      }
      phoneControl.setValue(value, { emitEvent: false }); // Actualizar sin disparar eventos adicionales
    }
  }
  

  onSubmit() {
    if (!this.calcularMayorEdad(this.form.get('fechaNacimiento').value)) {
      Swal.fire('Oops!', 'Debes ser mayor de edad para continuar.', 'warning');
      return;
    }
    if (this.persona.estadoSituacion?.estadoFormularioSituacion == 'Firmado') {
      this.stepperService.nextStep();
      return;
    }
    if (!this.form.invalid) {
      const formData = this.form.getRawValue();
      var url = `estado-situacion/${this.personaService.getPersonaGuid()}/identificacion-persona`;
      this.dataService.postData(formData, url).subscribe({
        next: (v) => {
          this.personaService.persona$.subscribe((persona) => {
            if (persona) {
              this.persona = persona;
              const updatedData = persona.estadoSituacion?.personaAntecedentesConviviente;
              if (updatedData.guid){
                updatedData.anoCursa = 0;
                updatedData.apellidoMaterno = "";
                updatedData.apellidoPaterno = "";
                updatedData.arriendos = 0;
                updatedData.carrera = "";
                updatedData.celular = "";
                updatedData.email = "";
                updatedData.honorarios = 0;
                updatedData.nivelEstudios = undefined;
                updatedData.nombre = "";
                updatedData.otros = 0;
                updatedData.retiros = 0;
                updatedData.rut = "";
                updatedData.sueldo = 0;
                updatedData.tipoCarrera = null;
                updatedData.totalIngresos = null;
                if (this.form.get('tipoEstadoCivil').value !== 'Casado' && this.form.get('tipoEstadoCivil').value !== 'ConvivienteCivil') {
                  const convivienteUrl = `estado-situacion/${this.personaService.getPersonaGuid()}/antecedentes-conviviente`;
                  this.dataService.postData(updatedData, convivienteUrl).subscribe({
                    next: (v) => {
                      console.log("conviviente eliminado");
                    }
                  });
              }
              }
            }
          });
          this.stepperService.nextStep();
        },
      error: (e) => console.log(e),
      complete: () => this.personaService.setPersona()
      });
    } else {
      this.form.markAllAsTouched();
    }
  }

  tipoNacionalidadChange(event: any){
    if(event == 'Chileno'){
      this.form.get('paisNacionalidad').disable();
      this.form.get('paisNacionalidad').setValue( 'Chile');
    }
    else{
      this.form.get('paisNacionalidad').enable();
      this.form.get('paisNacionalidad').setValue(null);
    }
  }

  tipoViviendaChange(event: any) {
    const otroTipoViviendaControl = this.form.get('otroTipoVivienda');
    const montoArriendoControl = this.form.get('montoArriendo');

    otroTipoViviendaControl.disable();
    otroTipoViviendaControl.setValue(null);
    otroTipoViviendaControl.removeValidators(Validators.required);

    montoArriendoControl.disable();
    montoArriendoControl.removeValidators(Validators.required);
    
    if (event === 'Otro') {
      otroTipoViviendaControl.enable();
      otroTipoViviendaControl.addValidators(Validators.required);
      montoArriendoControl.setValue(null);
    } else if (event === 'Arrendada') {
      montoArriendoControl.enable();
      montoArriendoControl.addValidators(Validators.required);
    } else if (event !== 'Arrendada') {
      montoArriendoControl.setValue(null);
    }

    otroTipoViviendaControl.updateValueAndValidity();
    montoArriendoControl.updateValueAndValidity();
  }
  
  tipoEstadoCivilChange(event: any) {
    const tipoRegimenPatrimonial = this.form.get('tipoRegimenPatrimonial');
    if (event === 'Casado' || event === 'ConvivienteCivil') {
      tipoRegimenPatrimonial.enable();
      tipoRegimenPatrimonial.setValidators(Validators.required);
      tipoRegimenPatrimonial.updateValueAndValidity();
    } else {
      tipoRegimenPatrimonial.disable();
      tipoRegimenPatrimonial.setValue(null);
      tipoRegimenPatrimonial.clearValidators();
      tipoRegimenPatrimonial.updateValueAndValidity();
    }
  }


  volver(){
    this.stepperService.prevStep();
  }
}
